import React from 'react';
import { useSelector } from 'react-redux';
import { useState, useEffect } from "react";
import useSnackbar from '../../../hooks/useSnackbar';
import { billPaymentRelationshipsContactsTable } from '../../../config/grid-column-defs';
import AgGridPaginatedTable from '../../../components/AgGridPaginatedTable';
import { getTransactionNotAvailable } from "../../../config/grid-value-formatters";

import { slugMap } from '../../../config/slug-config';
import { useParams } from 'react-router-dom';
import { Box, Grid, InputLabel, MenuItem, FormControl, Select, Tabs, Tab, CircularProgress } from '@mui/material';
import TabPanel from "../../../components/TabPanel";

export default function BillPaymentRelationship({ tabIndexP }) {
  const snackbar = useSnackbar();
  const { data: user } = useSelector(state => state.user);
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const pageDetail = slugMap[params.slug];

  // const [tableRefreshCount, setTableRefreshCount] = useState(0);
  // function refreshTable () {  
  //     setTableRefreshCount(prev => prev + 1);
  // }

  return (
    <>
      <Box>
        <Box className="sub-tab" sx={{ maxWidth: { xs: 320, sm: 480, md: "100%" }, bgcolor: '#fff' }}>
          <Tabs
            value={tabIndex}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndex(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="Contacts" />
          </Tabs>

          { /*Contacts*/}
          <TabPanel value={tabIndex} index={0}>
            <Box className="viewDetilsBox">

              <Grid container spacing={2}>
                <Grid item xs={12} sm={4} md={4} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">CONTACT</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="CONTACT"
                    >
                      <MenuItem value="list">List</MenuItem>
                      <MenuItem value="search">Search</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">ROLE</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="ROLE"
                    >
                      <MenuItem value="alternatecontact">Alternate Contact</MenuItem>
                      <MenuItem value="consultant">Consultant</MenuItem>
                      <MenuItem value="decisionmaker">Decision Maker</MenuItem>
                      <MenuItem value="ordercreator">Order Creator</MenuItem>
                      <MenuItem value="primarycontact">Primary Contact</MenuItem>
                      <MenuItem value="licensenotification">License Notification</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={4} md={3} className="m-b-10">
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">VIEW</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value=""
                      label="VIEW"
                    >
                      <MenuItem value="default">Default</MenuItem>
                      <MenuItem value="phone">Phone</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

              </Grid>

            </Box>

            {tabIndexP === 2 ?
             <Box className="viewDetilsBox"><AgGridPaginatedTable
                // getTableRows={getTransactionNotAvailable}
                columns={billPaymentRelationshipsContactsTable} perPage={5} refreshCounter={0}
              /></Box> 
              : <></>
            }
          </TabPanel>
          { /*Contacts*/}

        </Box>
      </Box>
    </>
  )
}



